import parentRow from "./parentRow.vue";
import childRow from "./childRow.vue";

export default {
  functional: true,
  props: ["suborder", "order"],
  render(createElement, context) {
    const parent = createElement(parentRow, { props: context.props, on: context.data.on });
    const child = createElement(childRow, { props: context.props });

    return [parent, child];
  },
};
